// extracted by mini-css-extract-plugin
module.exports = {"customSelect":"CustomSelect_customSelect__3_I66","customLabelWithBadge":"CustomSelect_customLabelWithBadge__3eWft","selectBox":"CustomSelect_selectBox__voRWc"};